import { IconBlock, IconLockLocked, IconPause, IconWarning } from "@humansignal/icons";
import { Tooltip } from "@humansignal/ui";
import "./ExtensionBadges.prefix.css";

/**
 * The labels an installed extension puts on a project
 * (``project.extensions.badges``: ``{label, tone, title, icon}``), as small
 * icons with the label in a tooltip: for cards with no room for words.
 * A badge without a known icon shows a warning sign.
 */
export type ExtensionBadge = { label: string; tone?: string; title?: string; icon?: string };

const ICONS = {
  lock: IconLockLocked,
  block: IconBlock,
  pause: IconPause,
  warning: IconWarning,
} as const;

export const ExtensionBadgeIcons = ({ badges }: { badges?: ExtensionBadge[] | null }) => {
  if (!badges?.length) return null;
  return (
    <span className="lsf-extension-badges" data-testid="extension-badge-icons">
      {badges.map((badge) => {
        const Icon = ICONS[(badge.icon ?? "") as keyof typeof ICONS] ?? IconWarning;

        return (
          <Tooltip key={badge.label} title={badge.title || badge.label}>
            <span
              className={`lsf-extension-badges__icon lsf-extension-badges__icon_${badge.tone ?? "neutral"}`}
              role="img"
              aria-label={badge.title || badge.label}
            >
              <Icon width={16} height={16} />
            </span>
          </Tooltip>
        );
      })}
    </span>
  );
};
